import { useSafeAreaInsets as original_useSafeAreaInsets } from 'react-native-safe-area-context';
import { Platform } from 'react-native';
import { Orientation } from 'expo-screen-orientation/src/ScreenOrientation.types';
import { useScreenOrientation } from '@/hooks/useScreenOrientation';

export function useSafeAreaInsets() {
  const { left, right, top, bottom } = original_useSafeAreaInsets();
  const orientation = useScreenOrientation();
  return {
    left: Platform.OS === 'ios' && orientation === Orientation.LANDSCAPE_LEFT ? 0 : left,
    right: Platform.OS === 'ios' && orientation === Orientation.LANDSCAPE_RIGHT ? 0 : right,
    top,
    bottom,
  };
}
